import { render, staticRenderFns } from "./GridField.vue?vue&type=template&id=23d81246"
import script from "./GridField.vue?vue&type=script&lang=js"
export * from "./GridField.vue?vue&type=script&lang=js"
import style0 from "./GridField.vue?vue&type=style&index=0&id=23d81246&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports